import { render, staticRenderFns } from "./volumeByCustomer.vue?vue&type=template&id=a0cb58f0&"
import script from "./volumeByCustomer.vue?vue&type=script&lang=js&"
export * from "./volumeByCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports